import Table from './tableGenerator.js';
import TextFileDownloader from './textFileDownloader.js';

(function (Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.eddiTimeSeries = {
    attach: function (context, settings) {
      once('generateTimeSeries', '#eddi-time-series', context).forEach(element => {

        require([
          "esri/geometry/geometryEngine",
          "esri/geometry/geometryEngineAsync",
          "esri/geometry/Polygon",
          "esri/geometry/support/webMercatorUtils",
          "esri/Graphic",
          "esri/layers/GraphicsLayer",
          "esri/Map",
          "esri/symbols/TextSymbol",
          "esri/views/draw/Draw",
          "esri/views/MapView",
          "esri/widgets/CoordinateConversion",
          "esri/widgets/Sketch",
          "esri/widgets/Sketch/SketchViewModel"
        ], (geometryEngine, geometryEngineAsync, Polygon, webMercatorUtils, Graphic, GraphicsLayer, Map, TextSymbol, Draw, MapView, CoordinateConversion, Sketch, SketchViewModel) => {

          console.log(drupalSettings.eddiTools);

          let regionInfo, regionExtent, xmax, xmin, ymax, ymin, nw, ne, se, sw, n, s, w, e, regionRings, xmin_lonwest, xmax_loneast, ymax_latnorth, ymin_latsouth, selectionRow, north, south, west, east, eddiData, eddiYears, eddiValues, plotTitle, monthEnd, monthScale, monthEndText, monthName, downloadPlot, mimeType, filename, linkSelector, alignVals, d3, masterTxtHeader, masterTxtData, masterTxt, plotTxtHeader, plotTxtData, plotTxt;

          let latNorth = document.querySelector('.bounding-coordinates #north');
          let latSouth = document.querySelector('.bounding-coordinates #south');
          let lonWest = document.querySelector('.bounding-coordinates #west');
          let lonEast = document.querySelector('.bounding-coordinates #east');
          let monthScaleOption = document.querySelector('#month-scale');
          let monthEndOption = document.querySelector('#end-month');
          let regionTitle = document.querySelector('#region-title');

          const months = [  
            'January', 'February', 'March', 'April',  
            'May', 'June', 'July', 'August',  
            'September', 'October', 'November', 'December'  
          ];

          const monthsShort = [  
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'  
          ];

          // The loading spinner
          const spinner = document.querySelector('#eddi-time-series .spinner');

          // Data availability notice area
          const dataAvailable = document.querySelector('.eddi-plot .data-available');

          // Data debug area
          const dataDebug = document.querySelector('#eddi-data-debug');

          const noticesPanel = document.querySelector('#eddi-time-series .notices-panel');

          // The "error" message display area
          const errorDiv = document.querySelector('#eddi-time-series .notices-panel .eddi-time-series-error');

          let errorMsg = `<p>An error occurred. Please try again or contact the web administrator.</p>`;

          // The "no maps" message area
          const noDataDiv = document.querySelector('#eddi-time-series .notices-panel .eddi-no-data');

          let noDataMsg = `<p>No time series data available. Please try a different region or options.</p>`;

          const plotPanel = document.querySelector('.plot-panel');

          const plotSvgContainer = document.querySelector('.svg-container');

          const plotMainSvgList = document.querySelectorAll(".main-svg");

          const plotDiv = document.querySelector('#eddi-time-series-plot');

          const plotTable = new Table('.eddi-selection-data', '.selection-table-wrapper');

          // Plot and table file download links
          const plotPngLink = document.querySelector('.plot-png-link');
          const plotTxtLink = document.querySelector('.plot-txt-link');
          const masterTxtLink = document.querySelector('.master-txt-link');

          const masterTableDiv = document.querySelector('#eddi-time-series .master-table-panel');

          /* Map variables */
          const tsGraphicsLayer = new GraphicsLayer();

          const tsRegionMap = new Map({
            basemap: "topo-vector",
            layers: [tsGraphicsLayer]
          });

          const tsMapView = new MapView({
            container: "time-series-map",
            map: tsRegionMap,
            zoom: 4,
            center: [-96.09, 38.84],
            constraints: {
              /*geometry: {
                type: "extent",
                xmin: -13916828,
                ymin: 2876520,
                xmax: -7459429,
                ymax: 6983615,
              },*/
              rotationEnabled: false
            }
          });
          /*tsMapView.constraints = {
            geometry: {
              type: "extent",
              xmin: -13916828,
              ymin: 2876520,
              xmax: -7459429,
              ymax: 6983615,
            },
            rotationEnabled: false
          }*/

          /*const ccWidget = new CoordinateConversion({
            view: tsMapView,
            visibleElements: {
              captureButton: false,
              editButton: false,
              settingsButton: false
            }
          });
          // Adds widget in the bottom left corner of the view
          tsMapView.ui.add(ccWidget, "bottom-left");*/
          
          /*
          const rectSymbol = new TextSymbol({
            color: '#7A003C',
            text: '\ue902',  // esri-icon-map-pin
            font: {  // autocast as new Font()
              size: 24,
              family: 'CalciteWebCoreIcons'
            }
          });
          */

          // Default vertices for College Park, MD region
          const defaultVertices = [
            [-8566944.184105096, 4721754.445136818],
            [-8562971.009861806, 4721754.445136818],
            [-8562971.009861806, 4717029.141312151],
            [-8566944.184105096, 4717029.141312151],
            [-8566944.184105096, 4721754.445136818]
          ]
          // Function to create geometry based on vertices
          const createGeometry = (vertices) => {
            return new Polygon({
              rings: vertices,
              spatialReference: tsMapView.spatialReference
            })
          };
          // Function to convert web mercator geometries to geographic
          const convertGeometry = (geometry) => {
            return webMercatorUtils.webMercatorToGeographic(geometry);
          }
          // Function to format longitude and latitude to 3 decimal places
          const formatLonLat = (coordinate) => {
            return Number.parseFloat(coordinate).toFixed(3);
          }
          // Function to format each region's color, opacity, and outline on the map
          const regionFillSymbol = (color, style, width, outlineColor) => {
            return {
              type: "simple-fill",
              style: style,
              color: color,
              outline: {
                color: outlineColor,
                width: width
              }
            };
          }
          // Function to sketch the default College Park, MD region box
          const sketchDefaultRegion = () => {
            const collegeParkGeometry = createGeometry(defaultVertices);
            const collegeParkSymbol = regionFillSymbol([35, 120, 195, 0.3], "solid", 2, [35, 120, 195]);
            // Create the College Park, MD region
            const collegeParkRegion = new Graphic({
              geometry: collegeParkGeometry,
              symbol: collegeParkSymbol,
              attributes: {
                region: "College Park, MD, USA"
              }
            });
            // Convert the geometry for the College Park, MD region to geographic
            const convertedGeometry = convertGeometry(collegeParkGeometry);
            // Get the vertices of the converted College Park, MD region box
            const collegeParkVertices = convertedGeometry.rings[0];
            // Get min/max x and y values of the College Park region box
            xmin = convertedGeometry.extent.xmin;
            xmax = convertedGeometry.extent.xmax;
            ymin = convertedGeometry.extent.ymin;
            ymax = convertedGeometry.extent.ymax;
            // Format each vertex in the College Park region to 3 decimal places
            nw = collegeParkVertices[0].map(formatLonLat);
            ne = collegeParkVertices[1].map(formatLonLat);
            se = collegeParkVertices[2].map(formatLonLat);
            sw = collegeParkVertices[3].map(formatLonLat);
            // Assign each cardinal direction (formatted to 3 decimal places)
            n = formatLonLat(ymax); // can also be nw[1] or ne[1]
            s = formatLonLat(ymin); // can also be sw[1] or se[1]
            w = formatLonLat(xmin); // can also be nw[0] or sw[0]
            e = formatLonLat(xmax); // can also be ne[0] or se[0]
            // Add each cardinal direction's coordinates to its respective input field
            latNorth.value = n;
            latSouth.value = s;
            lonWest.value = w;
            lonEast.value = e;
            regionTitle.value = collegeParkRegion.attributes.region;
            // Add the College Park, MD region to the map by default
            tsGraphicsLayer.add(collegeParkRegion);
          }

          const resetDefaultRegion = () => {
            // Clear the map
            tsGraphicsLayer.removeAll();
            // Clear the input fields
            latNorth.value = "";
            latSouth.value = "";
            lonWest.value = "";
            lonEast.value = "";
            regionTitle.value = "";
            setTimeout(() => {
              // Sketch the default College Park, MD region
              sketchDefaultRegion();
            }, 500);
          }

          /*let symbol = {
            //type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            type: "simple-fill",  // autocasts as new SimpleFillSymbol()
            //style: "square",
            style: "solid",
            //color: "blue",
            color: [150, 150, 150, 0.2],
            size: "8px",  // pixels
            outline: {  // autocasts as new SimpleLineSymbol()
              color: [ 255, 255, 0 ],
              width: 2  // points or "0.5px"
            }
          };*/

          /*const tsRegionModel = new SketchViewModel({
            layer: tsGraphicsLayer,
            view: tsMapView,
            //polygonSymbol: symbol,
            //activeTool: "rectangle",
            //availableCreateTools: ["rectangle"],
            //activeTool: "rectangle",
            // graphic will be selected as soon as it is created
            //creationMode: "single"
          })*/
          
          
          // constrain the map to a certain view extent
          function limitMapExtent(view) {
            var initialExtent = view.extent;
            view.watch('stationary', function(event) {
              if (!event) {
                return;
              }
              //If the map has moved to the point where it's center is
              //outside the initial boundaries, then move it back to the
              //edge where it moved out
              var currentCenter = view.extent.center;
              if (!initialExtent.contains(currentCenter)) {

                var newCenter = view.extent.center;

                //check each side of the initial extent and if the
                //current center is outside that extent,
                //set the new center to be on the edge that it went out on
                if (currentCenter.x < initialExtent.xmin) {
                  newCenter.x = initialExtent.xmin;
                }
                if (currentCenter.x > initialExtent.xmax) {
                  newCenter.x = initialExtent.xmax;
                }
                if (currentCenter.y < initialExtent.ymin) {
                  newCenter.y = initialExtent.ymin;
                }
                if (currentCenter.y > initialExtent.ymax) {
                  newCenter.y = initialExtent.ymax;
                }
                view.goTo(newCenter);
              }
            });
          }
          


          // When the map view is ready
          tsMapView.when(() => {

            setTimeout(() => {
              // Sketch the default College Park, MD region
              sketchDefaultRegion();
              tsMapView.goTo({
                center: [-76.94, 38.98],
                zoom: 13
              })
            }, 500) // After a slight delay
          
            //console.log(tsMapView.graphics);
            //console.log(tsGraphicsLayer.graphics);

            tsMapView.on('pointer-move', (event) => {
              let point = tsMapView.toMap({ x: event.x, y: event.y });
              //console.log("Point = ", point.x, point.y, point.latitude, point.longitude);
            });

            const tsRegionSketch = new Sketch({
              layer: tsGraphicsLayer,
              view: tsMapView,
              activeTool: "rectangle",
              availableCreateTools: ["rectangle"],
              // graphic will be selected as soon as it is created
              // User can update graphic after creation
              creationMode: "update",
              defaultUpdateOptions: {
                //tool: "reshape",
                tool: "transform",
                enableRotation: false,
                enableScaling: true,
                multipleSelectionEnabled: false,
                toggleToolOnClick: false // false disallows toggling to reshaping tool which creates different angles and shapes
              },
              visibleElements: {
                duplicateButton: false,
                selectionTools: {
                  "rectangle-selection": false,
                  "lasso-selection": false
                },
                settingsMenu: false,
                undoRedoMenu: false
              }
            });

            // Add the sketch widget to the view
            tsMapView.ui.add(tsRegionSketch, "top-right");

            // Begin with drawing tool cursor
            //tsRegionSketch.create("rectangle");

            // Listen to create and update events
            tsRegionSketch.on(["create"], async (event) => {
              // Remove any previous graphics from the layer first so there aren't multiple rectangles
              tsGraphicsLayer.removeAll();

              // Respond to create event while the cursor is being moved on the view.
              const eventInfo = event.toolEventInfo;
              console.log(eventInfo);

              if (event.state === "complete") {
                // Convert geometry to geographic
                regionInfo = webMercatorUtils.webMercatorToGeographic(event.graphic.geometry);
                // Extent of the region
                regionExtent = regionInfo.extent; // event.graphic.geometry.extent;
                // Rings (vertices) of the region
                regionRings = regionInfo.rings[0]; // event.graphic.geometry.rings[0]

                xmin = regionExtent.xmin; // regionInfo.extent.xmin;
                xmax = regionExtent.xmax; // regionInfo.extent.xmax;
                ymin = regionExtent.ymin; // regionInfo.extent.ymin;
                ymax = regionExtent.ymax; // regionInfo.extent.ymax;

                // Add the new graphic to the layer
                tsGraphicsLayer.add(event.graphic);

                /*const geometries = tsGraphicsLayer.graphics.map( (graphic) => {
                  return graphic.geometry;
                });*/
                //console.log("geometries = ", geometries);
                //const queryGeometry = await geometryEngineAsync.union(geometries.toArray());
                //console.log("queryGeometry = ", queryGeometry);
                //selectFeatures(queryGeometry);
                //console.log(event.graphic.geometry.rings[0]);
                //console.log(geometries);
                //console.log(event.graphic.geometry);

                //console.log("centroid (lat, lon): ", event.graphic.geometry.centroid.latitude, event.graphic.geometry.centroid.longitude);
                //console.log("center (lat, lon): ", event.graphic.geometry.extent.center.latitude, event.graphic.geometry.extent.center.longitude);

                console.log(event.graphic.geometry.rings);
                console.log("regionInfo = ", regionInfo);
                console.log("regionExtent = ", regionExtent);
                console.log("regionRings = ", regionRings);
                nw = regionRings[0];
                ne = regionRings[1];
                se = regionRings[2];
                sw = regionRings[3];
                n = Number.parseFloat(nw[1]).toFixed(3);
                e = Number.parseFloat(ne[0]).toFixed(3);
                s = Number.parseFloat(sw[1]).toFixed(3);
                w = Number.parseFloat(nw[0]).toFixed(3);

                console.log({ nw, ne, se, sw, n, e, s, w });
                latNorth.value = n;
                latSouth.value = s;
                lonWest.value = w;
                lonEast.value = e;
              }
              //let shapePoint = tsMapView.toMap({x: event.x, y: event.y});
              //console.log("Point = ", point.x, point.y, point.latitude, point.longitude);
            });
            // Respond to update event while the cursor is being moved on the view.
            tsRegionSketch.on("update", async (event) => {
              console.log("updating...", event);
              regionInfo = webMercatorUtils.webMercatorToGeographic(event.graphics[0].geometry);
              regionExtent = regionInfo.extent;
              regionRings = regionInfo.rings[0];

              if (
                event.toolEventInfo &&
                (event.toolEventInfo.type === "move-stop" || event.toolEventInfo.type === "scale-stop")
              ) {
                event.graphics.forEach(async (graphic) => {
                  console.log("graphic.geometry.rings = ", graphic.geometry.rings);
                  console.log("regionRings = ", regionRings);
                });
                console.log(regionRings[0]);
                console.log(regionRings[1]);
                console.log(regionRings[2]);
                nw = regionRings[0];
                ne = regionRings[1];
                se = regionRings[2];
                sw = regionRings[3];
                //n = nw[1];
                n = Number.parseFloat(nw[1]).toFixed(3);
                e = Number.parseFloat(ne[0]).toFixed(3);
                s = Number.parseFloat(sw[1]).toFixed(3);
                w = Number.parseFloat(nw[0]).toFixed(3);
                console.log({ nw, ne, se, sw, n, e, s, w });
                latNorth.value = n;
                latSouth.value = s;
                lonWest.value = w;
                lonEast.value = e;
              }

              if (event.state === "active") {
                //event.graphic.delete();
              }
              if (event.state === "complete") {
                //console.log("rings", event.graphics[0].geometry.rings);
                console.log(webMercatorUtils.webMercatorToGeographic(event.graphics[0].geometry));
                //console.log("regionInfo = ", regionInfo);
                //console.log("regionExtent = ", regionExtent);
                console.log("regionRings = ", regionRings);
              }
            });

            // fires after delete method is called
            // returns references to deleted graphics.
            tsRegionSketch.on("delete", async (event) => {
              // Reset the rectangle cursor
              tsRegionSketch.create("rectangle");
              event.graphics.forEach(async (graphic) => {
                console.log("deleted", graphic)
              });
            });

            // constrain the map to a certain view extent
            limitMapExtent(tsMapView);

          }); // end tsMapView.when()


          /*function addGraphics() {
            const vertices = [
              [-13040270.324055556, 4040357.7882640623],
              [-13038653.725694647, 4040689.513023534],
              [-13038063.204863824, 4038017.2028549737],
              [-13040097.818223165, 4037990.629044359],
              [-13040270.324055556, 4040357.7882640623]
            ];

            const polygon = createGeometry(vertices);
            validSymbol = createSymbol([0, 170, 255, 0.8], "solid", 2, [255, 255, 255]);
            newDevelopmentGraphic = new Graphic({
              geometry: polygon,
              symbol: validSymbol,
              attributes: {
                newDevelopment: "new store"
              }
            });

            const boundaryVertices = [
              [-13048353.166569024, 4041363.935436187],
              [-13036929.861699322, 4041363.935436187],
              [-13036929.861699322, 4030232.5692555667],
              [-13048353.166569024, 4030232.5692555667],
              [-13048353.166569024, 4041363.935436187]
            ];

            boundaryPolygon = createGeometry(boundaryVertices);
            const boundarySymbol = createSymbol([255, 255, 255, 0], "solid", 2, [255, 255, 255]);
            const boundaryGraphic = new Graphic({
              geometry: boundaryPolygon,
              symbol: boundarySymbol
            });
            graphicsLayer.addMany([newDevelopmentGraphic]);
            boundaryLayer.add(boundaryGraphic);
          }*/

          let timeSeriesUrl;

          const resetMapBtn = document.querySelector('#reset-map');

          resetMapBtn.addEventListener('click', e => {
            e.preventDefault();

            resetDefaultRegion();
            /*tsMapView.goTo({
              center: [0, 0],
              zoom: 2
            })*/
          })


          const showSpinner = () => {
            spinner.removeAttribute('hidden');
          }

          const hideSpinner = () => {
            spinner.setAttribute('hidden', '');
          }

          const clearPlot = () => {
            //dataAvailable.setAttribute('hidden', '');
            errorDiv.innerHTML = "";
            noDataDiv.innerHTML = "";

            plotPanel.setAttribute('hidden', '');
            plotTable.hide();
            //plotTableDiv.setAttribute('hidden', '');

            //dataDebug.replaceChildren();
            //[...plotTableBody.children].forEach(c => c.remove())
          }


          let update = 0;

          const plotTimeSeries = (eddiData, plotTitle) => {
            let d3 = Plotly.d3;
            downloadPlot = d3?.select('#plot');

            let negEddi = {
              x: eddiData.neg_years,
              y: eddiData.neg_values,
              type: 'bar',
              marker: {
                color: 'rgb(0, 104, 189)',
                opacity: 0.8,
                line: {
                  color: 'rgb(0, 104, 189)',
                  width: 1
                }
              },
              //hoverinfo: 'x+y',
              hoverlabel: {
                bgcolor: 'rgb(254, 230, 133)',
                bordercolor: 'rgb(255, 255, 255)',
                font: {
                  color: 'rgb(28, 29, 31)',
                  size: 11
                }
              },
              hovertemplate: '<b>Year</b>: %{x}<br>' +
                        '<b>EDDI</b>: %{y}<extra></extra>',
              connectgaps: false
            }

            let posEddi = {
              x: eddiData.pos_years,
              y: eddiData.pos_values,
              type: 'bar',
              marker: {
                color: 'rgb(181, 9, 9)',
                opacity: 0.8,
                line: {
                  color: 'rgb(181, 9, 9)',
                  width: 1
                }
              },
              //hoverinfo: 'x+y',
              hoverlabel: {
                bgcolor: 'rgb(254, 230, 133)',
                bordercolor: 'rgb(255, 255, 255)',
                font: {
                  color: 'rgb(28, 29, 31)',
                  size: 11
                }
              },
              hovertemplate: '<b>Year</b>: %{x}<br>' +
                        '<b>EDDI</b>: %{y}<extra></extra>',
              connectgaps: false
            }

            let data = [negEddi, posEddi];

            let layout = {
              autosize: true,
              barmode: 'relative',
              datarevision: update++,
              font: {
                family: 'Public Sans Web, Source Sans Pro, Arial, Helvetica, sans-serif'
              },
              showlegend: false,
              title: {
                text: plotTitle,
                font: {
                  family: 'Public Sans Web, Source Sans Pro, Arial, Helvetica, sans-serif',
                  size: 20,
                  textcase: 'word caps',
                  weight: 600,
                },
                subtitle: {
                  font: {
                    color: 'rgb(141, 146, 151)',
                    size: 12
                  },
                  text: `${west}W, ${east}W, ${south}N, ${north}N<br>Number of months calculated: ${monthScale} | Ending in: ${monthName} (${monthEnd})`,
                }
              },
              margin: {
                //l: 60,
                //r: 20,
                //t: 60,
                //b: 60
              },
              xaxis: {
                automargin: true,
                showgrid: true,
                gridcolor: "#f0f0f0",
                tickmode: "auto",
                //tickangle: -45,
                tick0: 1980,
                //dtick: 5,
                //tickfont: {
                //  weight: 300
                //},
                //ticklabelstep: 5,
                title: {
                  text: 'Year',
                  font: {
                    size: 16,
                    weight: 500
                  },
                  standoff: 20
                }
              },
              yaxis: {
                automargin: false,
                showgrid: true,
                gridcolor: "#f0f0f0",
                tickfont: {
                  weight: 400
                },
                title: {
                  text: 'EDDI Value',
                  font: {
                    size: 16,
                    weight: 500
                  }
                },
                zerolinewidth: 2
              },
              //height: 450,
              //width: 900
            }


            let printLayout = {
              title: {
                text: plotTitle,
                font: {
                  family: 'Public Sans Web, Source Sans Pro, Arial, Helvetica, sans-serif',
                  size: 36,
                  textcase: 'word caps',
                  weight: 600,
                },
                subtitle: {
                  font: {
                    color: 'rgb(141, 146, 151)',
                    size: 20
                  },
                  text: `${west}W, ${east}W, ${south}N, ${north}N<br>Number of months calculated: ${monthScale} | Ending in: ${monthName} (${monthEnd})`,
                }
              },
            }

            let config = {
              displaylogo: false,
              displayModeBar: false,
              //scrollZoom: true,
              //editable: true,
              /*modeBarButtonsToRemove: [
                'zoom2d',
                'pan2d',
                'lasso2d',
                'select2d',
              ],*/
              responsive: true,
              /*toImageButtonOptions: {
                //format: 'svg', // one of png, svg, jpeg, webp
                filename: 'EDDI image for ' + plotTitle,
                height: 1000,
                width: 1400,
                scale: 1 // Multiply title/legend/axis/canvas sizes by this factor
              }*/
            }
            //Plotly.newPlot(plotDiv, data, layout, config);
            Plotly.react(plotDiv, data, layout, config)
              .then(() => {
                plotPanel.removeAttribute('hidden');
              
              })
              .catch(error => {
                return console.error('Error:', error);
              })
            
            
            plotPngLink.addEventListener('click', (event) => {
              event.preventDefault();
              
              Plotly.downloadImage(plotDiv, {
                //data: [negEddi, posEddi],
                data: data,
                layout: printLayout,
                config: {
                  displaylogo: false,
                  displayModeBar: false
                },
                format: 'png',
                width: 1400,
                height: 1000,
                filename: `eddi${monthEnd}mo-${monthScale}mm_${west}W_${east}W_${south}N_${north}N`
                //filename: event.target.getAttribute('download')
              });
            });
            
            //Plotly.restyle(plotDiv, { 'line.color': 'red' }, 0);
            // Relayout the plot to change the title
            //Plotly.relayout(plotDiv, {'title': plotTitle});
            //dataAvailable.removeAttribute('hidden');

            //plotPanel.removeAttribute('hidden');
          }

          const getPlotFileData = (eddiData, txtHeader, monthScale) => {
            eddiYears = eddiData.all_years;
            eddiValues = eddiData.all_values;

            alignVals = eddiValues.map(val => val < 0 ? val : ' ' + val);

            let txtBody = '';

            for (let i=0; i < eddiYears.length; i++) {
              txtBody += eddiYears[i] + "\t" + monthScale + "\t" + alignVals[i] + "\n";
            }
            return txtHeader + txtBody;
          }

          const downloadTxtFile = (text, event) => {
            plotTxtData = new TextFileDownloader(text);

            plotTxtData.download(mimeType="text/plain", filename=event.target.getAttribute('download'), event);
          }



          async function fetchTimeSeries() {

            try {
              const response = await fetch(timeSeriesUrl);
              const obj = await response.json();
            
              // If there are no results, add the "No EDDI map found"
              // message to the map container
              if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);

              } else if (obj.error) {

                errorDiv.innerHTML = errorMsg;
              } else if (!obj.result) {

                noDataDiv.innerHTML = noDataMsg;
              // If there are results
              } else {
                eddiData = JSON.parse(obj.result);

                console.log(eddiData);
                console.log(eddiData.all_years + eddiData.all_values);
                console.log(monthScale);
                console.log(monthEnd);

                // Create plot
                plotTimeSeries(eddiData, plotTitle);

                // Set download button file names for png files
                //plotPngLink.setAttribute('download', `eddi${monthEnd}mo-${monthScale}mm_${west}W_${east}W_${south}N_${north}N.png`);

                // Set download button file names for txt files
                plotTxtLink.setAttribute('download', `eddi${monthEnd}mo-${monthScale}mm_${west}W_${east}W_${south}N_${north}N.txt`);

                masterTxtLink.setAttribute('download', `eddi_master_${west}W_${east}W_${south}N_${north}N.txt`);

                // Generate the plot table
                plotTable.generate(eddiData);
                plotTable.show();


                plotTxtHeader = `${west}W, ${east}W, ${south}N, ${north}N\n\n`;
                plotTxtHeader += `Number of months calculated (mm): ${monthScale}\n`;
                plotTxtHeader += `Ending month (eddi${monthEnd}mo): ${monthName}\n\n`;
                plotTxtHeader += "Year" + "\t" + "mm" + "\t" + `eddi${monthEnd}mo` + "\n";

                // Formatted text that will be downloaded
                plotTxt = getPlotFileData(eddiData, plotTxtHeader, monthScale);

                /*masterTxtHeader = `Number of months calculated (mm): ${monthEnd}\n`;
                masterTxtHeader += `Ending month (eddi${monthEnd}mo): ${monthName}\n\n`;
                masterTxtHeader += "Year" + "\t" + "mm" + "\t" + `eddi${monthEnd}mo` + "\n";                

                masterTxt = getPlotFileData(eddiData, masterTxtHeader, monthScale);*/

                console.log(plotTxt);
                //console.log(masterTxt);

                /*plotPngLink.addEventListener('click', (event) => {
                  event.preventDefault();
                  
                  Plotly.downloadImage(plotDiv, {
                    format: 'png',
                    width: 1400,
                    height: 1000,
                    filename: `eddi${monthEnd}mo-${monthScale}mm_${west}W_${east}W_${south}N_${north}N`
                    //filename: event.target.getAttribute('download')
                  })
                });*/

                // Click event listeners for downloading the table txt files
                plotTxtLink.addEventListener('click', (e) => {
                  downloadTxtFile(plotTxt, e);
                });

                /*masterTxtLink.addEventListener('click', (e) => {
                  downloadTxtFile(masterTxt, e);
                });*/

              }
            } catch (error) {
              //errorDiv.append(noMapErrorTag);
              console.error(error);
            } finally {
              hideSpinner();
            }
          };


          const generatePlotBtn = document.querySelector('#generate-plot');

          // When the generate plot button is clicked
          generatePlotBtn.addEventListener('click', e => {

            e.preventDefault();

            clearPlot();
            showSpinner();

            north = latNorth.value;
            //let north = 41.000;
            south = latSouth.value;
            //let south = 37.000;
            west = lonWest.value;
            //let west  = -109.000;
            east = lonEast.value;
            //let east  = -102.000;
            monthScale = monthScaleOption.value;
            //let monavg = 5;
            monthEnd = monthEndOption.value;
            //let monend = 9;
            let title = regionTitle.value;

            let selectedIndex = monthEndOption.selectedIndex;
            let selectedOption = monthEndOption.options[selectedIndex];

            monthEndText = selectedOption.text;
            plotTitle = title;

            // Using the value of monthEnd, get the full month name 
            // from the "months" array
            monthName = months[monthEnd - 1];

            // Construct the fetch url using the route and the
            // form variables as parameters
            timeSeriesUrl = `/climate-phenomena/drought/eddi/time-series/plot?north=${north}&south=${south}&west=${west}&east=${east}&monthScale=${monthScale}&monthEnd=${monthEnd}&title=${title}`;

            noticesPanel.scrollIntoView({ block: "center" });
            fetchTimeSeries();
          });


          const toFloat = (str) => {
            return parseFloat(str).toFixed(2);
          }

          const loadTable = () => {
            plotTable.generate(eddiData);
            plotTable.show();
          }


        }); // require

      }); // once
    } // attach
  }; // Drupal.behaviors

})(Drupal, drupalSettings);